<template>
  <div>
    <div key="ports" v-if="$store.state.ports !== null" class="flex-container">
      <div v-if="blocks.length === 0" class="msg flex-100">
        <awesomeIcon icon="exclamation-circle" />
        <!-- <font-awesome-icon icon="floppy-disk"/> -->
        Er is nog geen portefeuille gekoppeld aan uw account. Neem contact met ons op.
      </div>
      <div class="menubar flex-100">
        <div v-if="style == 'db'" class="title">Mijn doelen</div>
        <div v-else class="title hide-mobile">Mijn portefeuilles</div>
        <span style="float:right;">
          Totaal waarde <b>&euro; {{formatPrice(sumBy(blocks, 'value'), true)}}</b>
        </span>
        <span v-if="style == 'db'" class="hide-mobile" style="float:right;">
          Totaal doel <b>&euro; {{formatPrice(sumBy(blocks, 'target'), true)}}</b>
        </span>
      </div>
      <div v-for="p in blocks" :key="`block-${p.cardType}-${p.id}`" class="flex-33">
        <div
          v-if="p.cardType == 'port' || p.cardType == 'portredo'"
          class="port card option"
          @click="$store.state.currentPort=p.id;$store.state.currentView = 'Dashboard'"
        >
          <span class="port-number">
            <awesomeIcon v-if="p.type==0 || !p.type" icon="business-time"/>
            <awesomeIcon v-else-if="p.type==1" icon="heart"/>
            <awesomeIcon v-else-if="p.type==2" icon="home"/>
            <awesomeIcon v-else-if="p.type==3" icon="graduation-cap"/>
            <awesomeIcon v-else-if="p.type==4" icon="car"/>
            <awesomeIcon v-else-if="p.type==5" icon="golf-ball"/>
            <awesomeIcon v-else-if="p.type==6" icon="heart"/>
            <awesomeIcon v-else-if="p.type==7" icon="golf-ball"/>
            <awesomeIcon v-else-if="p.type==8" icon="heart"/>
            {{p.id}}
          </span>

          <div class="score-meter" v-if="p.brand == 'Doelbeleggen' && p.sat">
            <scoreWidget v-model="p.sat.score" :showNotice="false"/>
          </div>
          <awesomeIcon v-else class="wallet" icon="wallet"/>

          <h2>
            <template v-if="p.name">
              {{p.name}}
            </template>
            <template v-else-if="p.brand == 'Doelbeleggen'">
              <template v-if="p.type===0">Vermogensopbouw</template>
              <template v-else-if="p.type===1">Zorgpotje</template>
              <template v-else-if="p.type===2">Hypotheek</template>
              <template v-else-if="p.type===3">Studie kinderen</template>
              <template v-else-if="p.type===4">Grote aankoop</template>
              <template v-else-if="p.type===5">Pensioen</template>
              <template v-else-if="p.type===6">Levensonderhoud</template>
              <template v-else-if="p.type===7">Pensioen (Box 1)</template>
              <template v-else-if="p.type===8">Leefrente (Box 1)</template>
              <template v-else-if="p.type===9">Gouden handdruk (opbouwend)</template>
              <template v-else-if="p.type===10">Gouden handdruk (uitkerend)</template>
              <template v-else-if="p.type===11">Netto lijfrente (opbouwend)</template>
              <template v-else-if="p.type===12">Netto lijfrente (uitkerend)</template>
            </template>
            <template v-else>{{p.name ? p.name : 'Portefeuille'}}</template>
          </h2>

          <p
            v-if="
            p.value > 0
            && (
              new Date(p.date) > new Date(new Date().setDate(new Date().getDate()-7))
              || p.bank == 'BAL'
            )
            "
          >
            &euro; {{formatPrice(Number(p.value), true)}},-
            <template v-if="p.target && p.brand == 'Doelbeleggen'">
              van &euro; {{formatPrice(Number(p.target), true)}},-
            </template>
          </p>

          <p
            v-if="
              new Date(p.date) <= new Date(new Date().setDate(new Date().getDate()-7))
              && p.bank !== 'BAL'
              && p.bank !== 'GIRO'
            "
          >
            Gesloten
          </p>
          <p v-else-if="p.status == 3 && p.value >= 1">
            Bezig met sluiten
          </p>
          <p v-else-if="p.status == 3">
            Gesloten
          </p>
          <div class="redoCard"
            v-if="
              (p.brand === 'Doelbeleggen' || p.brand === 'OXBY')
              && (
                p.action_required
                || (
                  p.cardType == 'portredo'
                  && (p.redo.status == 'Bezig'|| ( p.redo.status == 'Ingeleverd' && ibanChanged(p)))
                )
              )
            "
          >
            <span class="port-number">
              <awesomeIcon v-if="p.type==0 || !p.type" icon="business-time" />
              <awesomeIcon v-else-if="p.type==1" icon="heart" />
              <awesomeIcon v-else-if="p.type==2" icon="home" />
              <awesomeIcon v-else-if="p.type==3" icon="graduation-cap" />
              <awesomeIcon v-else-if="p.type==4" icon="car" />
              <awesomeIcon v-else-if="p.type==5" icon="golf-ball" />
              <awesomeIcon v-else-if="p.type==6" icon="heart" />
              <awesomeIcon v-else-if="p.type==7" icon="golf-ball" />
              <awesomeIcon v-else-if="p.type==8" icon="heart" />
              {{p.id}}
            </span>
            <div class="incompleteProfile">
              {{ p.redo.status === 'Ingeleverd' && ibanChanged(p)
                ? 'Actie vereist'
                : 'Onvolledig klantprofiel'
              }}
              <div style="margin-top: 5px; font-size: 12px; padding: 0 30px;">
                {{ p.redo.status === 'Ingeleverd' && ibanChanged(p)
                  ? 'Er ontbreekt nog een identificatiestorting, klik hier om uw storting te doen'
                  : 'klik hier om uw klantprofiel af te ronden'
                }}
              </div>
            </div>
          </div>

          <!-- Als door gebruiker gemaakt, alleen dan tonen -->
          <div v-if="
              (p.cardType == 'portredo' && (p.redo.status === 'Bezig'|| ibanChanged(p))
              && (p.brand === 'Doelbeleggen' || p.brand === 'OXBY')) && (p.start === 'user')
            " class="red" @click.stop @click="stopIntake(p.redo.id, true)"
            style="padding: 10px;position: absolute;bottom: 0px;right: 0px">
            Herintake verwijderen
          </div>
        </div>
        <div
          v-if="
            p.cardType == 'intake'
            && (
              p.brand === 'Doelbeleggen'
              || p.brand === 'OXBY'
              || (
                (p.brand === 'VMVB' || p.brand === 'BVS')
                && ($parent.role > 7 || sdk.isBecome)
              )
            )
          "
          class="intake card option"
          @click="openIntake(p.id, p.brand)"
        >
          <div v-if="p.brand == 'Doelbeleggen'" class="score-meter">
            <scoreWidget v-model="p.score" :showNotice="false"/>
          </div>
          <awesomeIcon v-else class="wallet" icon="wallet"/>

          <h2 style="text-transform:capitalize;">
            <template v-if="p.brand != 'Doelbeleggen'">
              {{p.brand}} intake
            </template>
            <template v-else>
              <template v-if="p.type===0">Vermogensopbouw</template>
              <template v-else-if="p.type===1">Zorgpotje</template>
              <template v-else-if="p.type===2">Hypotheek</template>
              <template v-else-if="p.type===3">Studie kinderen</template>
              <template v-else-if="p.type===4">Grote aankoop</template>
              <template v-else-if="p.type===5">Pensioen</template>
              <template v-else-if="p.type===6">Levensonderhoud</template>
              <template v-else-if="p.type===7">Pensioen (Box 1)</template>
              <template v-else-if="p.type===8">Leefrente (Box 1)</template>
              <template v-else-if="p.type===9">Gouden handdruk (opbouwend)</template>
              <template v-else-if="p.type===10">Gouden handdruk (uitkerend)</template>
              <template v-else-if="p.type===11">Netto lijfrente (opbouwend)</template>
              <template v-else-if="p.type===12">Netto lijfrente (uitkerend)</template>
              <template v-else>Nieuw doel</template>
            </template>
          </h2>
          <p>
            &euro; {{formatPrice(Number(p.value), true)}},-
            <template v-if="p.target">
              van &euro; {{formatPrice(Number(p.target), true)}},-
            </template>
          </p>

          <div class="port-number">
            <awesomeIcon icon="exclamation-circle" />
            <span v-if="p.status == 'Bezig'">
              Vragenlijst #{{p.id}} nog niet afgerond
            </span>
            <span v-else-if="p.status == 'Ingeleverd'">
              Opstellen van uw beleggingsplan
            </span>
            <span v-else-if="p.status == 'Geaccepteerd'">
              U kunt het beleggingsplan ondertekenen
            </span>
            <span v-else>
              Bezig met het opzetten van uw portefeuille
            </span>
          </div>

          <div
            v-if="p.status == 'Bezig'"
            class="red" @click.stop @click="stopIntake(p.id)"
            style="padding: 10px;position: absolute;bottom: 0px;right: 0px"
          >
            Annuleren
          </div>
        </div>
      </div>
      <div
        v-if="
          (style === 'db' || ($parent.role > 7 || sdk.isBecome))
          && !lock
          && filter(
            blocks,
            (o) => o.cardType === 'intake'&& o.status !== 'Ondertekend'
          ).length === 0
        "
        class="promo flex-100" @click="startIntakeModal=true"
      >
          <img src="../assets/bgs/confetti.svg" class="confetti left"/>
          {{
            style !== 'db' && ($parent.role > 7 || sdk.isBecome)
              ? sdk.isBecome
                ? `Start een nieuw doel voor de klant ${$parent.role > 7 ? '(admin)' : ''}`
                : `Start een nieuw doel ${$parent.role > 7 ? '(admin)' : ''}`
              : 'Start een nieuw doel!'
          }}
          <img src="../assets/bgs/confetti.svg" class="confetti right"/>
      </div>
    </div>
    <div v-else key="loader" class="loader"></div>
    <!-- Delete reason modal -->
    <modalWindow v-if="deleteReasonModal" @close="clearReasonInput()" width="600">
      <div class="titlebar">Doel verwijderen</div>
      <div
        class="form-notice"
      >
        <strong>Let op:</strong><br />
        U staat op het punt om het doel te verwijderen. Geef hieronder aan waarom u het doel wilt
        verwijderen?
      </div>
      <form @submit.prevent class="inset">
        <select v-model="reason" ref="reason" placeholder="Reden van verwijderen"
        >
          <option value="Onjuist telefoonnummer">Onjuist telefoonnummer</option>
          <option value="Voicemail onbeantwoord">Voicemail onbeantwoord</option>
          <option value="Telefoon onbeantwoord" selected>Telefoon onbeantwoord</option>
          <option value="Whatsapp onbeantwoord">Whatsapp onbeantwoord</option>
          <option value="Gaat zelf beleggen">Gaat zelf beleggen</option>
          <option value="Kiest voor concurrent">Kiest voor concurrent</option>
          <option value="Kiest voor rente">Kiest voor rente</option>
          <option value="Aversie beleggen">Aversie beleggen</option>
          <option value="Wil beslissing uitstellen">Wil beslissing uitstellen</option>
          <option value="Kan risico niet dragen">Kan risico niet dragen</option>
          <option value="Wil geen telefonisch contact">Wil geen telefonisch contact</option>
          <option value="Administratieve fout">Administratieve fout</option>
          <option value="Betwiste aanvraag">Betwiste aanvraag</option>
          <option value="Bounced email">Bounced email</option>
          <option value="Test account">Test account</option>
        </select>
        <select
          v-if="reason === 'Kiest voor concurrent'"
          v-model="reasonParty"
          ref="reasonParty"
          placeholder="Concurrent"
        >
          <option value="ABN">ABN</option>
          <option value="ASR">ASR</option>
          <option value="Axento">Axento</option>
          <option value="BLG">BLG</option>
          <option value="BeSmart">BeSmart</option>
          <option value="Brand new day">Brand new day</option>
          <option value="Bright">Bright</option>
          <option value="Centraalbeheer">Centraalbeheer</option>
          <option value="Dexxi">Dexxi</option>
          <option value="Evi Van Lanschot">Evi Van Lanschot</option>
          <option value="Fintessa">Fintessa</option>
          <option value="Fitvermogen">Fitvermogen</option>
          <option value="ING">ING</option>
          <option value="Index people">Index people</option>
          <option value="Jouw">Jouw</option>
          <option value="Knab">Knab</option>
          <option value="Meesman">Meesman</option>
          <option value="NNEK">NNEK</option>
          <option value="Nationale Nederlanden">Nationale Nederlanden</option>
          <option value="OAKK">OAKK</option>
          <option value="Ostrica">Ostrica</option>
          <option value="Rabobank">Rabobank</option>
          <option value="Reaal">Reaal</option>
          <option value="SNS">SNS</option>
          <option value="Semmie">Semmie</option>
          <option value="Van Lanschot">Van Lanschot</option>
          <option value="iBeleggen">iBeleggen</option>
          <option value="Anders">Anders</option>
        </select>
        <textarea
          v-if="reasonParty === 'Anders'"
          v-model="otherPartyReason"
          ref="otherPartyReason"
          placeholder="Omschrijf de concurrent"
        />
        <p
          class="msg"
          style="margin-bottom: 0px"
          v-if="
            deleteErrorText
            && (
              !reason
              || (
                reason === 'Kiest voor concurrent'
                && (!reasonParty || reasonParty === 'Anders' && !otherPartyReason)
              )
            )
          "
        >
          {{ deleteErrorText }}
        </p>
        <input type=submit @click="stopIntakeWithReason(selectedId)" value="Verwijderen">
      </form>
    </modalWindow>
    <!-- Intake Modal -->
    <modalWindow v-if="startIntakeModal" @close="startIntakeModal=false" width="400">
      <div class="titlebar">Nieuw doel</div>
      <div class="inset">
        U kunt meerdere doelen openen. Wanneer u doorgaat, start u een (nieuwe)
        vragenlijst die past bij uw nieuwe doel. Heeft u al een doel, dan staan de
        meeste antwoorden nog ingevuld vanuit uw vorige vragenlijst, zo bent u sneller klaar.
        <button @click="newIntake">
          <awesomeIcon icon="plus"/> Doorgaan
        </button>
        <button @click="startIntakeModal=false" class="second">
          <awesomeIcon icon="ban"/> Annuleren
        </button>
      </div>
    </modalWindow>
  </div>
</template>

<script>
import {
  filter,
  find,
  findIndex,
  sumBy,
} from 'lodash-es';
import scoreWidget from './ui/scoreMeter';

export default {
  components: {
    scoreWidget,
  },
  name: 'UserHome',
  data() {
    return {
      blockstyle: true,
      deleteErrorText: '',
      deleteReasonModal: false,
      lock: false,
      otherPartyReason: '',
      reason: 'Telefoon onbeantwoord',
      reasonParty: '',
      selectedId: null,
      startIntakeModal: false,
      style: process.env.VUE_APP_STYLE,
    };
  },
  computed: {
    blocks() {
      const blocks = [...this.$store.state.ports];

      for (let i = 0; i < blocks.length; i += 1) {
        blocks[i].cardType = 'port';
      }

      for (let i = 0; i < this.$store.state.intakes.length; i += 1) {
        const intake = this.$store.state.intakes[i];

        let values = {};
        let adminValues = {};
        try {
          values = JSON.parse(intake.intake || '{}');
        } catch (e) {
          // eslint-disable-next-line
          console.log(`Intake ${intake.id} failed to parse intake`);
        }
        try {
          adminValues = JSON.parse(intake.admin || '{}');
        } catch (e) {
          // eslint-disable-next-line
          console.log(`Intake admin ${intake.id} failed to parse intake`);
        }
        if (find(blocks, { id: intake.port })) {
          blocks[findIndex(blocks, { id: intake.port })].cardType = 'portredo';
          blocks[findIndex(blocks, { id: intake.port })].redo = {
            id: intake.id,
            status: intake.status,
          };
        } else {
          blocks.push({
            cardType: 'intake',
            id: intake.id,
            status: intake.status,
            goal: values.goalData ? `${values.goalData.type}` : '?',
            brand: adminValues.beleggen ? `${adminValues.beleggen.brand}` : '',
            score: values.goalData ? Number(values.goalData.score || 0) : 0,
            value: intake.value,
            target: values.goalData ? Number(values.goalData.doel || 0) : 0,
            start: adminValues.start ? adminValues.start : '',
          });
        }
      }

      return blocks;
    },
  },
  methods: {
    filter,
    sumBy,
    ibanChanged(p) {
      const intake = find(this.$store.state.intakes, { id: p.redo.id, value: 0 });
      if (intake) {
        return JSON.parse(intake.intake).goalData.vtrChanged;
      }
      return false;
    },
    stopIntakeWithReason(id) {
      const intake = find(this.$store.state.intakes, { id });
      if (intake) {
        if (
          !this.reason
          || (this.reason === 'Kiest voor concurrent' && !this.reasonParty)
          || (this.reasonParty === 'Anders' && !this.otherPartyReason)
        ) {
          if (!this.reason) {
            this.deleteErrorText = 'Kies alsjeblieft een reden.';
          } else if (this.reason === 'Kiest voor concurrent' && !this.reasonParty) {
            this.deleteErrorText = 'Kies alsjeblieft een concurrent.';
          } else {
            this.deleteErrorText = 'Omschrijf alsjeblieft de concurrent.';
          }
        } else {
          const intakeData = JSON.parse(intake.intake);
          intakeData.delete = this.reason;
          if (this.reason === 'Kiest voor concurrent') {
            intakeData.deleteParty = this.reasonParty === 'Anders' ? this.otherPartyReason : this.reasonParty;
          }
          this.sdk.updateIntake(id, JSON.stringify(intakeData), () => {
            this.sdk.deleteIntake(id, () => {
              this.sdk.getIntakes((response) => {
                this.$store.state.intakes = response.data;
                this.clearReasonInput();
              });
            });
          });
        }
      }
    },
    clearReasonInput() {
      this.reason = 'Telefoon onbeantwoord';
      this.reasonParty = '';
      this.otherPartyReason = '';
      this.selectedId = null;
      this.deleteReasonModal = false;
    },
    brandname() {
      if (process.env.VUE_APP_STYLE === 'ox') {
        return 'OXBY';
      }
      if (process.env.VUE_APP_STYLE === 'db') {
        return 'Doelbeleggen';
      }
      if (process.env.VUE_APP_STYLE === 'vm') {
        return 'VMVB';
      }
      if (process.env.VUE_APP_STYLE === 'bvs') {
        return 'BVS';
      }
      return false;
    },
    openIntake(id) {
      window.location.href = `?intake=${id}`;
    },
    stopIntake(id, redo = false) {
      if (this.sdk.isBecome && Number(this.$parent.role) <= 0 && !redo) {
        // Delete intake from client as admin
        this.selectedId = Number(id);
        this.deleteReasonModal = true;
      } else {
        this.$store.state.confirm.toggle({
          text: redo
            ? 'Weet u zeker dat u deze herintake wilt verwijderen?'
            : 'Weet u zeker dat u dit doel wilt annuleren?',
          cb: (confirmed) => {
            if (confirmed) {
              this.sdk.deleteIntake(id, () => {
                this.sdk.getIntakes((response) => {
                  this.$store.state.intakes = response.data;
                });
              });
            }
          },
        });
      }
    },
    newIntake() {
      if (!this.lock) {
        this.lock = true;
        this.sdk.createIntake(
          (response) => {
            if (response.status === 200) {
              window.location.href = `?intake=${response.data.intake}`;
            }
            this.lock = false;
          },
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.redoCard {
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.9);
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  .incompleteProfile {
    font-size: 1.5em;
    font-weight: 600;
    color: #000066;
    text-align: center;
  }
}
.flex-container {
  column-gap: 20px;
  row-gap: 20px;
  @media #{$mobile} {
    row-gap: 10px;
    padding: 43px 10px 10px;
  }
}
.port,
.intake {
  .card-notice {
    position: absolute;
    top: 30px;
    right: 40px;
  }
  .port-number {
    position: absolute;
    top: 30px;
    left: 40px;
  }
  h2, h3, p {
    margin-top: 0px;
    text-align: center;
  }
  .score-meter {
    width: 180px;
    height: 180px;
    margin: 0px auto;
    margin-top: 15px;
  }
  .wallet {
    width: 127px;
    height: 127px;
    color: rgba(#000, 0.1);
    margin: 40px auto 28px;
    display: block;
    transition: color .2s;
  }
}
.promo {
  color: rgba(#000, 0.8);
  background-color: $color-grey-dark;
  padding: 10px;
  @media #{$mobile} {
    padding: 20px;
  }
  overflow: hidden;
  cursor: pointer;
  border-radius: $br;
  position: relative;
  text-align: center;
  .confetti {
    position: absolute;
    width: 100px;
    height: 100px;
    opacity: 0.2;
    &.right {
      right: -19px;
      top: -20px;
    }
    &.left {
      left: -5px;
      top: 2px;
    }
  }
  &:hover {
    background-color: darken($color-grey-dark, 5%);
  }
}
.msg {
  margin-bottom: 20px;
}
</style>
